/* eslint-disable no-unused-vars */
import axios from '../../helpers/Axios'

export const companymodule = {

	namespaced: true,

	state: {

		companyData: {},
		companyGroup: {},
		dataLoaded: false
	},
	getters: {

		companyData: state => { return state.companyData; }
	},
	actions: {

		getCompany({ commit }, companyId) {
			commit('dataLoaded', false);

			return axios.get('/company/get-company/' + companyId).then(response => {
				commit('companyData', response.data);
				commit('dataLoaded', true);
			}).catch(err => {
				console.log(err);
				commit('dataLoaded', false);
				global.location.replace('/error/error404');
			});
		},

		getCompanyGroup({ commit }, companyId) {
			return axios.get('/company/get-company-group/' + companyId).then(response => {
				commit('companyGroup', response.data);
			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		companyData(state, companyData) {
			state.companyData = companyData
		},
		companyGroup(state, companyGroup) {
			state.companyGroup = companyGroup
		},
		dataLoaded(state, dataLoaded) {
			state.dataLoaded = dataLoaded
		}
	}

}
